import {
  NgModule
} from '@angular/core';

import {
  SharedCommonModule
} from '../common';

import {
  MainLayoutComponent
} from './main-layout.component';
import {
  Util
} from '../../services/util';

import {
  UserContext
} from '../../services/user-context';
import {NavigationComponent} from './components/navigation/navigation.component';
import {NavigationModule} from './components/navigation/navigation.module';
import {PageHeaderModule} from './components/page-header/page-header.module';
import {MatExpansionModule} from '@angular/material/expansion';
import {VariantComponent} from '../../products/variant.component';

@NgModule({
  imports: [
    SharedCommonModule,
    NavigationModule,
    PageHeaderModule,
    MatExpansionModule,
  ],
  declarations: [
    MainLayoutComponent
  ],
  exports: [
    MainLayoutComponent
  ],
  providers: [
    Util,
    UserContext
  ],
  entryComponents: [],
})
export class MainLayoutModule {
}
